import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=299f7036&scoped=true"
import script from "./contactWay.vue?vue&type=script&lang=js"
export * from "./contactWay.vue?vue&type=script&lang=js"
import style0 from "./contactWay.vue?vue&type=style&index=0&id=299f7036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_5m75i4emtyicl3b24xpdtjfpha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f7036",
  null
  
)

export default component.exports